import { RouterModule } from '@angular/router';
import { PipesModule } from '../pipes/pipes.module';
import {FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';
import { PaginationComponent } from './pagination/pagination.component';
import {NgModule, ModuleWithProviders, forwardRef} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader/loader.component';
import { SearchInputComponent } from './search-input/search-input.component';
import { DataTableComponent } from './data-table/data-table.component';
import { NavComponent } from './nav/nav.component';
import { RangeComponent } from './range/range.component';
import { CategoryTreeComponent } from './category-tree/category-tree.component';
import { NotifyComponent } from './notify/notify.component';
import { SearchFormComponent } from './search-form/search-form.component';
import { LengthAwarePaginatorComponent } from './length-aware-paginator/length-aware-paginator.component';
import { SortByFieldComponent } from './sort-by-field/sort-by-field.component';
import { PerPageComponent } from './per-page/per-page.component';
import { MultiPurposeSearchComponent } from './multi-purpose-search/multi-purpose-search.component';
import { WizardNavComponent } from './wizard-nav/wizard-nav.component';
import { OptionsTreeComponent } from './options-tree/options-tree.component';
import { InputMaskDirective } from './input-mask/input-mask.directive';
import { DateTimePickerDirective } from './date-time-picker/date-time-picker.directive';
import { CountryFieldComponent } from './country-field/country-field.component';
import { InputSwitchDirective } from './input-switch/input-switch.directive';
import { ProductCardComponent } from './product-card/product-card.component';
import { ShelfComponent } from './shelf/shelf.component';
import { DragDropDirectiveModule } from 'angular4-drag-drop';
import { NgxBarcodeModule } from 'ngx-barcode';
import { InputCheckboxDirective } from './input-checkbox/input-checkbox.directive';
import { BarcodeScannerDetectorDirective } from './barcode-scanner-detector/barcode-scanner-detector.directive';
import { BlockDirective } from './block/block.directive';
import { AutoresizeDirective } from './autoresize/autoresize.directive';
import { PhoneInputComponent } from './phone-input/phone-input.component';
import { CustomSelectionComponent } from './custom-selection/custom-selection.component';
import { InputDateComponent } from './input-date/input-date.component';
import { ProductImageDirective } from './product-image/product-image.directive';
import {ApiModule} from '../../api/api.module';
import { CopyableDirective } from './copyable/copyable.directive';
import {StickynoteableDirective} from "./stickynoteable/stickynoteable.directive";
import {LogHistoryComponent} from "./log-history/log-history.component";
import {CartruleConditionComponent} from "./cartrule-condition/cartrule-condition.component";
import {HistoryPopUpComponent} from "./history-pop-up/history-pop-up.component";
import {ConstantTranslatorDirective} from "./constant-translator/constant-translator.directive";
import {CustomAttributeComponent} from "./custom-attribute/custom-attribute.component";
import {NgSelectModule} from "@ng-select/ng-select";
import {ImageZoomDirective} from "./image-zoom/image-zoom.directive";
import { UploadFileDirective } from './upload-file/upload-file.directive';
import { NgxPicaModule } from '@digitalascetic/ngx-pica';

@NgModule({
  imports: [CommonModule,NgxPicaModule, FormsModule, RouterModule, PipesModule, DragDropDirectiveModule, NgxBarcodeModule, ApiModule, NgSelectModule],
  entryComponents: [CartruleConditionComponent],
  exports: [
    PaginationComponent,
    UploadFileDirective,
    LoaderComponent,
    SearchInputComponent,
    DataTableComponent,
    RangeComponent,
    CategoryTreeComponent,
    NotifyComponent,
    SearchFormComponent,
    LengthAwarePaginatorComponent,
    SortByFieldComponent,
    PerPageComponent,
    MultiPurposeSearchComponent,
    WizardNavComponent,
    OptionsTreeComponent,
    InputMaskDirective,
    DateTimePickerDirective,
    CountryFieldComponent,
    InputSwitchDirective,
    ProductCardComponent,
    ShelfComponent,
    InputCheckboxDirective,
    BarcodeScannerDetectorDirective,
    BlockDirective,
    AutoresizeDirective,
    PhoneInputComponent,
    CustomSelectionComponent,
    InputDateComponent,
    ProductImageDirective,
    CopyableDirective,
    StickynoteableDirective,
    LogHistoryComponent,
    CartruleConditionComponent,
    HistoryPopUpComponent,
    ConstantTranslatorDirective,
    CustomAttributeComponent,
    ImageZoomDirective
  ],
  declarations: [
    PaginationComponent,
    LoaderComponent,
    SearchInputComponent,
    DataTableComponent,
    RangeComponent,
    CategoryTreeComponent,
    NotifyComponent,
    SearchFormComponent,
    LengthAwarePaginatorComponent,
    SortByFieldComponent,
    PerPageComponent,
    MultiPurposeSearchComponent,
    UploadFileDirective,
    WizardNavComponent,
    OptionsTreeComponent,
    InputMaskDirective,
    DateTimePickerDirective,
    CountryFieldComponent,
    InputSwitchDirective,
    ProductCardComponent,
    ShelfComponent,
    InputCheckboxDirective,
    BarcodeScannerDetectorDirective,
    BlockDirective,
    AutoresizeDirective,
    PhoneInputComponent,
    CustomSelectionComponent,
    InputDateComponent,
    ProductImageDirective,
    CopyableDirective,
    StickynoteableDirective,
    LogHistoryComponent,
    CartruleConditionComponent,
    HistoryPopUpComponent,
    ConstantTranslatorDirective,
    CustomAttributeComponent,
    ImageZoomDirective
  ]
})
export class DirectivesModule {}
